import React from 'react'
import { Input, makeStyles, Tooltip, Avatar } from '@material-ui/core'
import CustomTable from '../table/CustomTable'
import { numberFromText } from '../../utils/helpers'
import { AvatarGroup } from '@material-ui/lab'
import moment from 'moment'
import MomentUtils from '@date-io/moment'
import { occupationsObject } from '../../utils/dicts'
import { extractDayRange } from '../../utils/extractDate'

import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers'
import UserAvatar from '../shared/UserAvatar'
import TabNavigation from '../shared/TabNavigation'
import StyledSVG from '../shared/StyledSVG'
import { colors } from '../../utils/constants'

import closeSideBarArrow from '../../assets/icons/arrowlfts.svg'
import groupMessageSVG from '../../assets/icons/message-group.svg'
import CalendarSVG from '../../assets/icons/calendar.svg'
import warningSVG from '../../assets/icons/chat-warning.svg'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
    fontFamily: 'Montserrat, Source Sans Pro'
  },
  page_title: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 8,
    '& h1': {
      margin: 0,
      fontSize: 20,
      color: '#386093',
      fontWeight: 600
    }
  },
  goback_arrow: {
    position: 'absolute',
    left: '-20px',
    cursor: 'pointer'
  },
  header: {
    backgroundColor: '#ADB8CC33',
    height: '20%',
    padding: '32px 0px 0px 32px',
    overflow: 'auto',
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%',
      height: '8px',
      backgroundColor: 'white'
    }
  },
  description: {
    fontSize: 14,
    width: '60%'
  },
  main: {
    padding: '32px 0px 0px 32px',
    height: '80%',
    overflow: 'auto'
  },
  label_wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: '100%',
    rowGap: 8,
    '& h1': {
      color: '#4D5E80',
      fontWeight: 500,
      fontSize: 18,
      lineHeight: '100%',
      margin: 0
    },
    '& p': {
      fontWeight: 400,
      fontSize: 16,
      lineHeight: '150%',
      margin: 0
    }
  },
  last_message_date: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    width: 140,
    height: 25
  },
  last_message_wrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 8
  },
  tableRootClass: {
    '& .MuiTable-root': {
      borderCollapse: 'unset !important',
      borderSpacing: '0px 8px !important'
    }
  },
  pending_messages: {
    width: 35,
    height: 35,
    borderRadius: 16,
    backgroundColor: '#EF7C8F',
    color: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& p': {
      margin: 0
    }
  },
  tab_navigation: {
    width: 550,
    margin: '24px 0px 32px 0px'
  },
  name_input: {
    '& .MuiInputBase-input::placeholder': {
      fontFamily: 'Montserrat, Source Sans Pro',
      fontWeight: 500,
      fontSize: 14,
      lineHeight: '120%',
      color: '#ADB8CC',
      opacity: 1
    },
    alignItems: 'flex-start',
    '& input, & textarea': {
      paddingTop: 8,
      paddingLeft: 8
    },
    width: 650,
    height: 48,
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
    border: '1px solid #ADB8CC',
    '& .Mui-focuse': {
      border: '1px solid #ADB8CC'
    },
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '5px'
    },
    '&::-webkit-scrollbar-track': {
      '-webkit-border-radius': '10px',
      'border-radius': '10px'
    },
    '&::-webkit-scrollbar-thumb': {
      '-webkit-border-radius': '10px',
      'border-radius': '10px',
      background: 'rgba(173, 184, 204, 1)'
    }
  },
  search_form: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 32,
    marginBottom: 36
  },
  search_field: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 8,
    justifyContent: 'flex-start',
    '& p': {
      fontSize: 12,
      fontWeight: 600,
      lineHeight: '100%',
      margin: 0
    }
  },
  date_input: {
    '& div.MuiOutlinedInput-root': {
      borderRadius: '8px',
      height: '48px',
      width: 150,
      paddingLeft: 0,
      [theme.breakpoints.down('426')]: {
        height: '35px'
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        border: '1px solid #ADB8CC'
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        border: '1px solid #ADB8CC'
      },
      '& input': {
        minWidth: 'auto',
        '&:-webkit-autofill,input:-webkit-autofill:focus': {
          transition: 'background-color 600000s 0s, color 600000s 0s'
        }
      },
      '& .MuiInputAdornment-positionEnd': {
        width: 24,
        '& .MuiIconButton-root': {
          padding: '10px 7px'
        }
      }
    },
    '& div.MuiFormControl-marginNormal': {
      margin: 0,
      width: '100%',
      [theme.breakpoints.down('426')]: {
        width: 255
      }
    },
    '& fieldset': {
      border: '1px solid #ADB8CC'
    },
    '& input:-internal-autofill-selected': {
      background: 'none'
    }
  },
  avatar_name: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '17px',
    letterSpacing: '0em',
    textAlign: 'left'
  },
  avatar_label_wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    rowGap: 4
  },
  user_avatar_wrapper: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 8
  },
  user_avatar: {
    display: 'block !important',
    width: 'fit-content'
  },
  archived_table: {
    backgroundColor: 'unset',
    '& .MuiTable-root': {
      borderCollapse: 'separate !important',
      borderSpacing: '0px 12px !important'
    }
  },
  labels_style: {
    '& h1': {
      fontWeight: 600,
      fontSize: 16,
      margin: 0,
      lineHeight: '100%'
    },
    '& p': {
      color: '#9F9F9F',
      fontWeight: 400,
      margin: 0,
      fontSize: 14,
      lineHeight: '150%'
    }
  },
  archived_by: {
    textAlign: 'center',
    width: 'fit-content',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  simple_table_attribute: {
    color: '#868E96',
    fontWeight: 500,
    fontSize: 16,
    lineHeight: '100%',
    margin: 0,
    width: 'fit-content'
  },
  group_room: {
    cursor: 'pointer',
    display: 'flex',
    gap: 8,
    padding: '8px 8px'
  },
  cover_image: {
    width: 40,
    height: 40,
    borderRadius: 50
  }
}))

const ArchivedMessages = ({
  getRooms,
  roomsReducer,
  history,
  currentUser,
  setArchivedType,
  archivedRoomType,
  handleCloseArchivedSection
}) => {
  const classes = useStyles()
  const sagasParams = {
    withoutFractalIdFilter: true,
    archivedRooms: true
  }
  const [formFields, setFormFields] = React.useState({
    name: '',
    date: null
  })
  const [searchParams, setSearchParams] = React.useState({})

  const columns = [
    {
      key: 'room',
      name: 'Conversa',
      width: '25%',
      render: row => {
        if (row.room_type === 'private') {
          const schoolRoom = !row.room_participants.find(
            item => +item.user.fractal_id === +currentUser.attributes.fractal_id
          )

          const otherParticipant = row.room_participants.find(item => {
            return (
              +item?.user?.fractal_id !== +currentUser.attributes.fractal_id
            )
          })

          const roomName = schoolRoom
            ? `${row.room_participants?.[0]?.user?.name} + ${
                row.room_participants?.[1]?.user?.name
              }`
            : otherParticipant?.user?.name
          return schoolRoom ? (
            <div className={classes.user_avatar_wrapper}>
              <AvatarGroup max={2} spacing={1}>
                {row.room_participants.slice(0, 2).map((user, idx) => {
                  const index =
                    numberFromText(user?.user?.name?.slice(0, 2)) %
                    colors.length
                  return (
                    <Tooltip
                      key={`user[${idx}]`}
                      title={user?.user?.name}
                      arial-label='usuario'
                    >
                      <Avatar
                        src={user?.user?.avatar_url}
                        style={{
                          height: '30px',
                          width: '30px',
                          backgroundColor:
                            // eslint-disable-next-line standard/computed-property-even-spacing
                            colors[index]
                        }}
                      >
                        <p className={classes.avatar_name}>
                          {user?.user?.name?.[0] || ''}
                        </p>
                      </Avatar>
                    </Tooltip>
                  )
                })}
              </AvatarGroup>
              <div
                className={`${classes.avatar_label_wrapper} ${
                  classes.labels_style
                }`}
              >
                <h1>{roomName}</h1>
              </div>
            </div>
          ) : (
            <div className={classes.user_avatar_wrapper}>
              <UserAvatar
                avatarUrl={otherParticipant?.user?.avatar_url}
                userName={roomName}
                withoutUserName
                className={classes.user_avatar}
              />
              <div
                className={`${classes.avatar_label_wrapper} ${
                  classes.labels_style
                }`}
              >
                <h1>{roomName}</h1>
                <p>{occupationsObject[otherParticipant.occupation_name]}</p>
              </div>
            </div>
          )
        } else {
          return (
            <div className={classes.group_room}>
              {row.cover_image_url ? (
                <img
                  src={row.cover_image_url}
                  className={classes.cover_image}
                />
              ) : (
                <StyledSVG src={groupMessageSVG} width={40} height={40} />
              )}
              <div
                className={`${classes.avatar_label_wrapper} ${
                  classes.labels_style
                }`}
              >
                <h1>{row?.name}</h1>
                <p>{`${row?.room_participants?.length} membros`}</p>
              </div>
            </div>
          )
        }
      }
    },
    {
      key: 'archived_by',
      name: 'Arquivado por',
      width: '25%',
      align: 'right',
      render: row => {
        return (
          <div className={`${classes.archived_by} ${classes.labels_style}`}>
            <h1>{row?.archiver?.name}</h1>
            <p>{'Administrador da escola'}</p>
          </div>
        )
      }
    },
    {
      key: 'archived_reason',
      name: 'Motivo ',
      width: '25%',
      render: row => {
        return (
          <p className={classes.simple_table_attribute}>
            {row?.archived_reason}
          </p>
        )
      }
    },
    {
      key: 'date',
      name: 'Data',
      width: '25%',
      render: row => {
        return (
          <p className={classes.simple_table_attribute}>
            {`${moment(row.archived_at).format('DD/MM/YYYY')} - ${moment(
              row.archived_at
            ).format('HH:mm')}`}
          </p>
        )
      }
    }
  ]

  React.useEffect(() => {
    getRooms({
      ...sagasParams
    })
  }, [])

  React.useEffect(
    () => {
      const extractedArchivedDate = extractDayRange(formFields?.date)
      const updatedParams = {
        ...(formFields.name.length > 0
          ? archivedRoomType === 1
            ? { 'q[room_participants_user_name_cont]': formFields.name }
            : { 'q[name_cont]': formFields.name }
          : {}),
        ...(extractedArchivedDate
          ? {
              'q[archived_at_gteq]': extractedArchivedDate.beginningOfDay,
              'q[archived_at_lteq]': extractedArchivedDate.endOfDay
            }
          : {})
      }
      setSearchParams(updatedParams)
      getRooms({
        ...sagasParams,
        params: updatedParams
      })
    },
    [formFields]
  )

  const handleClickRoom = room => {
    handleCloseArchivedSection()
    history.push(`/rooms/${room.id}`)
  }

  const handleChangeNameInput = event => {
    setFormFields(prev => {
      return {
        ...prev,
        name: event.target.value
      }
    })
  }

  const handleChangeDateInput = event => {
    if (event === null) {
      setFormFields(prev => ({ ...prev, date: null }))
    } else {
      setFormFields(prev => ({
        ...prev,
        date: moment(event).format('YYYY-MM-DD')
      }))
    }
  }

  const handleChangeRoomType = roomType => {
    setArchivedType(roomType)
    getRooms({
      ...sagasParams
    })
  }

  return (
    <div className={classes.root}>
      <header className={classes.header}>
        <div className={classes.page_title}>
          <StyledSVG src={warningSVG} height={20} width={20} />
          <h1>Conversas arquivadas</h1>
          <StyledSVG
            width={14}
            height={14}
            className={classes.goback_arrow}
            src={closeSideBarArrow}
            alt='closeSideBarArrow'
            onClick={() => handleCloseArchivedSection()}
          />
        </div>
        <p className={classes.description}>
          Conversas arquivadas não aparecem mais na lista principal e permanecem
          disponíveis apenas para consulta e acompanhamento administrativo.
        </p>
      </header>
      <main className={classes.main}>
        <div className={classes.label_wrapper}>
          <h1>Histórico de arquivamento</h1>
          <p>
            Acompanhe todas as conversas arquivadas e os motivos informados.
          </p>
        </div>

        <TabNavigation
          defaultOption={archivedRoomType}
          baseClass={classes.tab_navigation}
          options={[
            {
              id: 1,
              key: 'Conversas diretas',
              handleChange: () => {
                handleChangeRoomType(1)
              }
            },
            {
              id: 0,
              key: 'Grupos',
              handleChange: () => {
                handleChangeRoomType(0)
              }
            }
          ]}
        />
        <div className={classes.search_form}>
          <div className={classes.search_field}>
            <p>Buscar</p>
            <Input
              disableUnderline
              multiline
              classes={{ root: classes.name_input }}
              placeholder={
                archivedRoomType === 1
                  ? 'Digite o nome do participante'
                  : 'Digite o nome do grupo'
              }
              onChange={handleChangeNameInput}
              value={formFields.name}
            />
          </div>
          <div className={`${classes.search_field} ${classes.date_input}`}>
            <MuiPickersUtilsProvider
              libInstance={moment}
              utils={MomentUtils}
              locale={'pt-br'}
            >
              <p>Período</p>
              <KeyboardDatePicker
                variant='inline'
                disableToolbar
                autoOk
                inputVariant='outlined'
                invalidDateMessage={'Data inválida'}
                InputAdornmentProps={{ position: 'end' }}
                format='DD/MM/yyyy'
                margin='normal'
                placeholder='00/00/00'
                value={formFields.date ? moment(formFields.date) : null}
                onChange={event => handleChangeDateInput(event)}
                keyboardIcon={
                  <StyledSVG
                    width={16}
                    height={16}
                    color='#ADB8CC'
                    src={CalendarSVG}
                  />
                }
                KeyboardButtonProps={{
                  'aria-label': 'change date'
                }}
              />
            </MuiPickersUtilsProvider>
          </div>
        </div>
        <CustomTable
          onRowClick={handleClickRoom}
          columns={columns}
          from={'archived_rooms'}
          data={roomsReducer.archivedRooms.items}
          classRoot={classes.archived_table}
          sagasParams={sagasParams}
          fetchItems={getRooms}
          isFetching={roomsReducer.archivedRooms.isFetching}
          pagination={{
            ...roomsReducer.archivedRooms.pagination,
            pageCount: roomsReducer.archivedRooms.pagination.totalCount
          }}
          params={searchParams}
          border={'none'}
          columnsPointer={[0, 1, 2, 3]}
          headCellRadius
          headColor={'rgba(173, 184, 204, 0.3)'}
        />
      </main>
    </div>
  )
}

export default ArchivedMessages
